/**
 * @generated SignedSource<<2c89963e686ed5f50c6aa3a13a05e3e4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type helpCenterTopic_HelpCenterQuery$data = {
  readonly helpCenter: {
    readonly helpCenterTopicById: {
      readonly __typename: "QueryError";
      readonly description?: string | null | undefined;
      readonly extensions?: ReadonlyArray<{
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly items?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly ari: string;
            readonly data: {
              readonly " $fragmentSpreads": FragmentRefs<"helpObject_HelpCenterHelpObject">;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly message?: string | null | undefined;
      readonly name?: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "helpCenterTopic_HelpCenterQuery";
};
export type helpCenterTopic_HelpCenterQuery$key = {
  readonly " $data"?: helpCenterTopic_HelpCenterQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpCenterTopic_HelpCenterQuery">;
};

import HelpCenterTopicQuery_graphql from './HelpCenterTopicQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "helpCenter",
  "helpCenterTopicById",
  "items"
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "kind": "RootArgument",
      "name": "helpCenterAri"
    },
    {
      "kind": "RootArgument",
      "name": "topicId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": HelpCenterTopicQuery_graphql
    }
  },
  "name": "helpCenterTopic_HelpCenterQuery",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "HelpCenterQueryApi",
      "kind": "LinkedField",
      "name": "helpCenter",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "helpCenterAri",
              "variableName": "helpCenterAri"
            },
            {
              "kind": "Variable",
              "name": "topicId",
              "variableName": "topicId"
            }
          ],
          "kind": "LinkedField",
          "name": "helpCenterTopicById",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "name"
                },
                {
                  "kind": "ScalarField",
                  "name": "description"
                },
                {
                  "alias": "items",
                  "concreteType": "HelpCenterTopicItemConnection",
                  "kind": "LinkedField",
                  "name": "__mainHelpObjectsList_HelpCenterTopic_items_connection",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "HelpCenterTopicItemEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "HelpCenterTopicItem",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "ari"
                            },
                            {
                              "kind": "LinkedField",
                              "name": "data",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "FragmentSpread",
                                  "name": "helpObject_HelpCenterHelpObject"
                                }
                              ]
                            },
                            (v1/*: any*/)
                          ]
                        },
                        {
                          "kind": "ScalarField",
                          "name": "cursor"
                        }
                      ]
                    },
                    {
                      "concreteType": "PageInfo",
                      "kind": "LinkedField",
                      "name": "pageInfo",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "endCursor"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "hasNextPage"
                        }
                      ]
                    }
                  ]
                }
              ],
              "type": "HelpCenterTopic"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "message"
                },
                {
                  "kind": "LinkedField",
                  "name": "extensions",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "statusCode"
                    }
                  ]
                }
              ],
              "type": "QueryError"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "42cc0b084b4d28f98b3c8d837eeafab7";

export default node;
